import React, { useState } from "react";

export const DesktopDownloadNextStepPrompt = ({
  guidedNextSteps,
  guidedText,
  onSkip,
  onTake,
  promptStep,
  promptStepIndex,
  resourceUI
}) => {
  const meta = promptStep?.meta || {};
  const title = promptStep?.type === "share"
    ? resourceUI.share
    : (meta.title || "Next step");
  const description = promptStep?.type === "share"
    ? resourceUI.share_desc
    : (meta.subtitle || resourceUI.default_subtitle || "");
  const howTo = promptStep?.type === "share"
    ? []
    : (meta.howTo || []);

  return (
    <div
      style={{
        flex: 1,
        width: "100%",
        minHeight: 0,
        background: "linear-gradient(to bottom right, oklch(0.22 0.04 265), oklch(0.18 0.03 265))",
        color: "#ffffff",
        padding: 24,
        display: "flex",
        flexDirection: "column",
        fontFamily: "system-ui, -apple-system, sans-serif"
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          color: "oklch(0.72 0.18 260)",
          fontSize: 14,
          fontWeight: 500
        }}
      >
        <svg
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
          style={{ width: 16, height: 16 }}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
        <span>Your download is complete</span>
      </div>

      <h3
        style={{
          margin: "18px 0 0",
          color: "#ffffff",
          fontSize: 22,
          lineHeight: 1.2,
          fontWeight: 600,
          letterSpacing: 0
        }}
      >
        {guidedText.timeCallout || "3 minutes now can save your life later."}
      </h3>
      <div
        style={{
          marginTop: 14,
          color: "#f8fafc",
          fontSize: 14,
          lineHeight: 1.625,
          fontWeight: 500
        }}
      >
        Take the next step before you go.
      </div>

      <div
        style={{
          marginTop: 20,
          borderRadius: 16,
          border: "1px solid #566071",
          background: "#202633",
          padding: 24,
          boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1)"
        }}
      >
        <div
          style={{
            color: "#ffc400",
            fontSize: 15,
            fontWeight: 800,
            letterSpacing: "0.05em",
            textTransform: "uppercase"
          }}
        >
          Next step · {Math.min(promptStepIndex + 1, guidedNextSteps.length)} of {guidedNextSteps.length}
        </div>
        <h4
          style={{
            margin: "4px 0 0",
            color: "#ffc400",
            fontSize: 28,
            lineHeight: 1.2,
            fontWeight: 800
          }}
        >
          {title}
        </h4>
        {description && (
          <div
            style={{
              marginTop: 12,
              color: "#f8fafc",
              fontSize: 16,
              lineHeight: 1.625,
              fontWeight: 500
            }}
          >
            {description}
          </div>
        )}
        {howTo.length > 0 && (
          <ul
            style={{
              margin: "12px 0 0",
              paddingLeft: 20,
              color: "#f8fafc",
              fontSize: 16,
              lineHeight: 1.625
            }}
          >
            {howTo.map((item, idx) => (
              <li key={`${item}-${idx}`} style={{ marginBottom: 8 }}>
                {item}
              </li>
            ))}
          </ul>
        )}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 12,
          marginTop: "auto",
          paddingTop: 24
        }}
      >
        <button
          type="button"
          onClick={onTake}
          style={{
            border: "none",
            borderRadius: 12,
            background: "#0877dc",
            color: "#ffffff",
            padding: "12px 16px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            cursor: "pointer",
            fontSize: 17,
            fontWeight: 800
          }}
        >
          <span>Take next step</span>
          <span aria-hidden="true" style={{ fontSize: 20, lineHeight: 1 }}>›</span>
        </button>
        <button
          type="button"
          onClick={onSkip}
          style={{
            border: "1px solid #566071",
            borderRadius: 12,
            background: "#252c38",
            color: "#ffffff",
            padding: "12px 16px",
            cursor: "pointer",
            fontSize: 17,
            fontWeight: 800
          }}
        >
          I will skip it
        </button>
      </div>
    </div>
  );
};

export const DownloadSharePrompt = ({ isMobile, onShare, onDismiss }) => {
  const [hasShared, setHasShared] = useState(false);

  const handleShare = () => {
    onShare?.(hasShared);
    setHasShared(true);
  };

  return (
    <div
      style={{
        flex: 1,
        width: "100%",
        height: "100%",
        minHeight: "inherit",
        background: "oklch(0.16 0.02 265)",
        color: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        fontFamily: "system-ui, -apple-system, sans-serif"
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          minHeight: "100%",
          borderRadius: 0,
          border: "1px solid rgba(255,255,255,0.1)",
          background: "linear-gradient(to bottom right, oklch(0.22 0.04 265), oklch(0.18 0.03 265))",
          padding: isMobile ? 24 : 32,
          boxShadow: "0 25px 50px -12px rgba(0,0,0,0.5)",
          animation: "fadeInUp 500ms ease-out"
        }}
      >
        <style>{`
          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(8px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}</style>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            fontSize: 14,
            fontWeight: 500,
            color: "oklch(0.72 0.18 260)"
          }}
        >
          <svg
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
            style={{ width: 16, height: 16 }}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
          <span>Your download is complete</span>
        </div>
        <h3
          style={{
            margin: "12px 0 0",
            fontSize: 24,
            fontWeight: 600,
            color: "#ffffff",
            lineHeight: 1.2
          }}
        >
          Before you leave, consider this...
        </h3>
        <div
          style={{
            marginTop: 20,
            display: "flex",
            flexDirection: "column",
            gap: 16,
            fontSize: 16,
            lineHeight: 1.625,
            color: "rgba(255,255,255,0.8)"
          }}
        >
          <p style={{ margin: 0 }}>You miss the alert in the night, will your neighbor wake you up?</p>
          <p style={{ margin: 0 }}>Are your family members aware of this information?</p>
          <p style={{ margin: 0, color: "#ffffff" }}>
            Please share this with one neighbor or family member to help them prepare.
          </p>
        </div>
        <div
          style={{
            marginTop: 32,
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: 8
          }}
        >
          <button
            type="button"
            onClick={handleShare}
            style={{
              border: "none",
              borderRadius: 6,
              background: "oklch(0.62 0.22 260)",
              color: "#ffffff",
              padding: "10px 24px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              cursor: "pointer",
              fontSize: 14,
              fontWeight: 500,
              width: "100%",
              flex: isMobile ? "initial" : 1
            }}
          >
            <svg
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
              style={{ width: 16, height: 16 }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
              />
            </svg>
            <span>{hasShared ? "Share again" : "Yes, I will share"}</span>
          </button>
          <button
            type="button"
            onClick={() => onDismiss?.(hasShared)}
            style={{
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: 6,
              background: "transparent",
              color: "#ffffff",
              padding: "10px 24px",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              cursor: "pointer",
              fontSize: 14,
              fontWeight: 500,
              width: "100%",
              flex: isMobile ? "initial" : 1
            }}
          >
            {hasShared ? "Done" : "No, I won't share"}
          </button>
        </div>
      </div>
    </div>
  );
};

export const SimulationPdfDownloadSection = ({ pdfUrl, isMobile, onPdfAnalytics, onDownloadComplete }) => {
  const handleDownload = async () => {
    const fileName = "wui-cast-simulation-times.pdf";
    onPdfAnalytics?.("simulation_pdf_download_click");

    try {
      const res = await fetch(pdfUrl);
      if (!res.ok) throw new Error(`PDF download failed with ${res.status}`);
      const blob = await res.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(objectUrl);
    } catch (err) {
      console.error("Failed to download simulation PDF:", err);
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = fileName;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
    onDownloadComplete?.();
  };

  return (
    <section
      aria-labelledby="simulation-pdf-title"
      style={{
        marginTop: 32,
        paddingTop: 0,
        borderTop: "none",
        textAlign: "left",
        fontFamily: "system-ui, -apple-system, sans-serif"
      }}
    >
      <h3
        id="simulation-pdf-title"
        style={{
          fontSize: 18,
          fontWeight: 600,
          margin: 0,
          color: "#ffffff"
        }}
      >
        WUI-Cast Simulation times
      </h3>
      <p
        style={{
          marginTop: 4,
          marginBottom: 0,
          color: "rgba(255,255,255,0.6)",
          fontSize: 14,
          lineHeight: 1.4
        }}
      >
        Download your report containing FAQs and simulated evacuation times.
      </p>
      <div
        style={{
          marginTop: 16,
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "stretch" : "center",
          gap: 16,
          padding: 24,
          borderRadius: 16,
          border: "1px solid rgba(255,255,255,0.1)",
          background: "linear-gradient(135deg, #181a2e 0%, rgba(42, 28, 16, 0.55) 100%)",
          boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)"
        }}
      >
        <div
          aria-hidden="true"
          style={{
            flexShrink: 0,
            width: 48,
            height: 48,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 12,
            background: "rgba(95,97,224,0.2)",
            color: "#7b7de8"
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="16" y1="13" x2="8" y2="13" />
            <line x1="16" y1="17" x2="8" y2="17" />
            <line x1="10" y1="9" x2="8" y2="9" />
          </svg>
        </div>
        <div style={{ minWidth: 0, flex: 1 }}>
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: "#ffffff",
              margin: 0
            }}
          >
            Download report
          </div>
        </div>
        <button
          type="button"
          onClick={handleDownload}
          style={{
            border: "none",
            borderRadius: 6,
            background: "#5f61e0",
            color: "#ffffff",
            padding: "8px 16px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            cursor: "pointer",
            fontSize: 14,
            fontWeight: 500,
            whiteSpace: "nowrap"
          }}
        >
          <svg
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          <span>Download report</span>
        </button>
      </div>
    </section>
  );
};

export const ResourceStepCard = ({
  activeNextStep,
  activeNextStepIndex,
  activeResourceKey,
  canPlay,
  durationSec,
  guidedNextSteps,
  hiddenNextStepKeys,
  isMobile,
  onBack,
  onOpenResource,
  playResourceSegment,
  resourceIsPlaying,
  resourceProgress,
  resourceUI,
  seekWithinResourceSegment,
  skipActiveGuidedStep,
  stopResourcePlayback,
  toggleGuidedStepDetails,
  guidedText
}) => {
  const seg = activeNextStep.seg;
  const meta = activeNextStep.meta || {};
  const howTo = meta.howTo || ["Default step."];
  const areStepsHidden = isMobile && !hiddenNextStepKeys.includes(`show:${seg.key}`);
  const playedSec = durationSec
    ? Math.max(0, Math.min(resourceProgress[seg.key] || 0, durationSec))
    : 0;
  const audioPct = durationSec > 0
    ? Math.min(100, (playedSec / durationSec) * 100)
    : 0;
  const isAudioActive = activeResourceKey === seg.key;

  return (
    <div
      style={{
        background: "#202633",
        border: "1px solid #566071",
        borderRadius: 16,
        padding: isMobile ? 18 : 24,
        boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1)"
      }}
    >
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
        <div style={{ minWidth: 0 }}>
          <div style={{ color: "#ffc400", fontSize: isMobile ? 14 : 15, fontWeight: 800, letterSpacing: "0.05em", textTransform: "uppercase" }}>
            Step {activeNextStepIndex + 1} of {guidedNextSteps.length}
          </div>
          <h3 style={{ margin: "6px 0 0", fontSize: isMobile ? 25 : 28, lineHeight: 1.15, fontWeight: 800, color: "#ffc400" }}>
            {meta.title || "Step"}
          </h3>
        </div>
      </div>

      {(meta.subtitle || resourceUI.default_subtitle) && (
        <div style={{ marginTop: 14, color: "#f8fafc", fontSize: 16, lineHeight: 1.55 }}>
          {meta.subtitle || resourceUI.default_subtitle}
        </div>
      )}

      {!areStepsHidden && (
        <ul style={{ margin: "14px 0 0", paddingLeft: 22, color: "#f8fafc", fontSize: 16, lineHeight: 1.55 }}>
          {howTo.map((item, idx) => (
            <li key={idx} style={{ marginBottom: 10 }}>{item}</li>
          ))}
        </ul>
      )}

      {isAudioActive && canPlay && (
        <div
          style={{
            marginTop: 16,
            display: "flex",
            alignItems: "center",
            gap: 12,
            border: "1px solid rgba(255,255,255,0.12)",
            borderRadius: 12,
            padding: 10,
            background: "rgba(0,0,0,0.18)"
          }}
        >
          <button
            type="button"
            onClick={() => {
              if (resourceIsPlaying) {
                stopResourcePlayback();
              } else {
                playResourceSegment(seg, { resumeIfSame: true });
              }
            }}
            style={{
              background: resourceIsPlaying ? "#ef4444" : "#22c55e",
              color: "#111827",
              border: "none",
              borderRadius: 10,
              padding: "9px 12px",
              fontWeight: 900,
              cursor: "pointer",
              minWidth: 72
            }}
          >
            {resourceIsPlaying ? "Stop" : "Play"}
          </button>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              onClick={(event) => {
                const rect = event.currentTarget.getBoundingClientRect();
                const ratio = rect.width
                  ? Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width))
                  : 0;
                seekWithinResourceSegment(seg, ratio * durationSec, true);
              }}
              style={{
                height: 8,
                background: "rgba(255,255,255,0.18)",
                borderRadius: 999,
                cursor: "pointer",
                overflow: "hidden"
              }}
            >
              <div
                style={{
                  width: `${audioPct}%`,
                  height: "100%",
                  borderRadius: 999,
                  background: "#2f83ff"
                }}
              />
            </div>
          </div>
        </div>
      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: 8,
          marginTop: 24
        }}
      >
        <button
          type="button"
          onClick={() => onOpenResource(seg, meta)}
          style={{
            background: "#0877dc",
            color: "#fff",
            border: "none",
            borderRadius: 12,
            padding: "12px 16px",
            fontWeight: 800,
            fontSize: 17,
            cursor: "pointer"
          }}
        >
          {guidedText.doItNow || "Do it now"} ↗
        </button>
        {isMobile && (
          <button
            type="button"
            onClick={() => toggleGuidedStepDetails(seg.key, true)}
            style={{
              background: "#252c38",
              color: "#fff",
              border: "1px solid #566071",
              borderRadius: 12,
              padding: "12px 16px",
              fontWeight: 800,
              fontSize: 17,
              cursor: "pointer"
            }}
          >
            {areStepsHidden
              ? (guidedText.showSteps || "Show steps")
              : (guidedText.hideSteps || "Hide steps")}
          </button>
        )}
        <button
          type="button"
          onClick={skipActiveGuidedStep}
          style={{
            background: "#252c38",
            color: "#fff",
            border: "1px solid #566071",
            borderRadius: 12,
            padding: "12px 16px",
            fontWeight: 800,
            fontSize: 17,
            cursor: "pointer"
          }}
        >
          {guidedText.skip || "Skip"} ›
        </button>
      </div>

      {activeNextStepIndex > 0 && (
        <button
          type="button"
          onClick={onBack}
          style={{
            width: "100%",
            marginTop: 10,
            background: "transparent",
            color: "#f8fafc",
            border: "1px solid #566071",
            borderRadius: 12,
            padding: "11px 16px",
            cursor: "pointer",
            fontWeight: 800,
            fontSize: 15
          }}
        >
          {guidedText.back || "Back"}
        </button>
      )}
    </div>
  );
};

export const ShareStepCard = ({
  activeNextStep,
  activeNextStepIndex,
  guidedNextSteps,
  isMobile,
  markNextStepComplete,
  onBack,
  resourceUI,
  shareWithNeighbors,
  skipActiveGuidedStep,
  uiText,
  guidedText
}) => (
  <div
    style={{
      background: "#202633",
      border: "1px solid #566071",
      borderRadius: 16,
      padding: isMobile ? 18 : 24,
      boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1)"
    }}
  >
    <div style={{ color: "#ffc400", fontSize: isMobile ? 14 : 15, fontWeight: 800, letterSpacing: "0.05em", textTransform: "uppercase" }}>
      Step {activeNextStepIndex + 1} of {guidedNextSteps.length}
    </div>
    <h3 style={{ margin: "6px 0 0", fontSize: isMobile ? 25 : 28, lineHeight: 1.15, fontWeight: 800, color: "#ffc400" }}>
      {resourceUI.share}
    </h3>
    <div style={{ marginTop: 14, color: "#f8fafc", fontSize: 16, lineHeight: 1.55 }}>
      {resourceUI.share_desc}
    </div>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
        gap: 12,
        marginTop: 24
      }}
    >
      <button
        type="button"
        onClick={() => {
          shareWithNeighbors();
          markNextStepComplete(activeNextStep.key);
        }}
        style={{
          background: "#0877dc",
          color: "#fff",
          border: "none",
          borderRadius: 12,
          padding: "12px 16px",
          fontWeight: 800,
          fontSize: 17,
          cursor: "pointer"
        }}
      >
        {uiText.share_button}
      </button>
      <button
        type="button"
        onClick={skipActiveGuidedStep}
        style={{
          background: "#252c38",
          color: "#fff",
          border: "1px solid #566071",
          borderRadius: 12,
          padding: "12px 16px",
          fontWeight: 800,
          fontSize: 17,
          cursor: "pointer"
        }}
      >
        {guidedText.skip || "Skip"} ›
      </button>
    </div>

    {activeNextStepIndex > 0 && (
      <button
        type="button"
        onClick={onBack}
        style={{
          width: "100%",
          marginTop: 10,
          background: "transparent",
          color: "#f8fafc",
          border: "1px solid #566071",
          borderRadius: 12,
          padding: "11px 16px",
          cursor: "pointer",
          fontWeight: 800,
          fontSize: 15
        }}
      >
        {guidedText.back || "Back"}
      </button>
    )}
  </div>
);
